export default __webpack_public_path__ + "static/card-1-01d761df63a87d1cb460580ce132892c.png";